import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { authCodeFlowConfig } from '../../environments/auth.config';
import { EmptyProfile, Profile } from '../general-components/profile/profile';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly loginLoading = new Subject<boolean>();
  constructor(private oauthService: OAuthService, private router: Router) {
    this.doConfigure();
  }

  public isLoading(): Observable<boolean> {
    return this.loginLoading.asObservable();
  }

  public login() {
    this.oauthService.initLoginFlow();
    this.router.navigate(['home']);
  }
  public logout() {
    this.oauthService.logOut();
    this.router.navigate(['home']);
  }

  public getUserInfo(): Profile {
    let claims = this.oauthService.getIdentityClaims();
    let profile = EmptyProfile();

    if (!claims) return profile;

    profile.firstName = claims.given_name;
    profile.lastName = claims.family_name;
    profile.emailAddress = claims.email;
    return profile;
  }

  public isAuthenticated(): boolean {
    return (
      this.oauthService.hasValidAccessToken() &&
      this.oauthService.hasValidIdToken()
    );
  }

  private doConfigure() {
    //this is needed so we can test configure
    this.configure();
  }

  private configure() {
    this.loginLoading.next(true);
    this.oauthService.configure(authCodeFlowConfig);
    this.oauthService.setupAutomaticSilentRefresh();
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService
      .loadDiscoveryDocumentAndTryLogin({
        customHashFragment: window.location.search,
      })
      .then(() => {
        try {
          this.oauthService.loadUserProfile().then(() => {});
          this.redirectIfPossible();
        } catch (error) {
          //it's fine, this happens when users arent logged in yet
        } finally {
          this.loginLoading.next(false);
        }
      });
  }

  redirectIfPossible() {
    let redirectURL = localStorage.getItem('redirectURL');
    if (redirectURL) {
      if (redirectURL?.charAt(0) == '/') {
        this.router.navigateByUrl(redirectURL);
      }
      localStorage.removeItem('redirectURL');
    }
  }
}
